import gql from 'graphql-tag';

import { executeGqlMutation, type GqlMutationOptions } from 'src/graphql/client';
import { getSingleProp } from 'src/lib/graphql';
import type {
  BackendMultiScoreSuggestionType,
  BackendMutationScoreCopyTextForDocumentEditorArgs,
} from 'src/types/backend';

const MUTATION = gql`
  mutation ScoreCopyTextForDocumentEditor(
    $projectId: ID!
    $brief: BriefInput
    $scoringMethod: ScoringMethodInput
    $generationTool: GenerationToolEnum!
    $text: String!
    $productName: String
    $annotations: [SuggestionAnnotationInput!]
  ) {
    scoreCopyTextForDocumentEditor(
      projectId: $projectId
      brief: $brief
      scoringMethod: $scoringMethod
      generationTool: $generationTool
      text: $text
      productName: $productName
      annotations: $annotations
    ) {
      score
      ageScoreHistogram
      genderScoreHistogram
      contentTaxonomyId
      engagementScoreSupportSize
      isEnterpriseScoreUsed
      language
      scoringMethod {
        id
        name
        type
      }
      secondaryScoringMethod {
        id
        name
        type
      }
    }
  }
`;

type Variables = BackendMutationScoreCopyTextForDocumentEditorArgs;
type Result = BackendMultiScoreSuggestionType;

export const scoreRewriteText = async (
  variables: Variables,
  options?: Pick<GqlMutationOptions, 'abortSignal'>
) => {
  const result = await executeGqlMutation({
    mutation: MUTATION,
    variables,
    options: {
      abortSignal: options?.abortSignal,
      traceAcRequests: true,
    },
  });
  return getSingleProp<Result>(result.data);
};
